"use client";

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "./useAuthStore";

interface UseAuthRedirectOptions {
  redirectTo?: string;
  disableRedirect?: boolean;
}

/**
 * Hook to handle authentication redirect logic
 */
export const useAuthRedirect = (options: UseAuthRedirectOptions = {}) => {
  const { redirectTo = "/login", disableRedirect = false } = options;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { initializeAuth, user, isAuthenticated, isFetching } = useAuthStore();

  // Initialize auth on pathname change
  useEffect(() => {
    initializeAuth();
  }, [pathname, initializeAuth]);

  // Handle redirect when not authenticated
  useEffect(() => {
    if (
      !disableRedirect &&
      !isFetching &&
      !isAuthenticated &&
      !user &&
      typeof window !== "undefined" &&
      !window.location.pathname.includes(redirectTo)
    ) {
      navigate(redirectTo);
    }
  }, [isFetching, isAuthenticated, user, navigate, redirectTo]);
};
